import React from 'react';
import classNames from 'classnames';
import styles from './volumeDiscount.scss';
import { IScalePrice, IPrice, IQuantityUnit } from '../../stores/types';
import { ILocalization } from '../../types';

function calculateDiscount (basePrice: number, scalePrice: number): string {
    const discount = (basePrice - scalePrice) / basePrice;
    const discountPercentage = (discount * 100).toFixed(0);
    return discountPercentage;
}

interface IVolumeDiscount {
    scalePrices: IScalePrice[];
    scalePriceTexts: string[][];
    basicPrice: IPrice;
    activePrice: IPrice;
    articleCount: number;
    quantityUnit: IQuantityUnit;
    onArticleCountChange(newCount: number): void,
    localization: ILocalization;
}

function VolumeDiscount(props: IVolumeDiscount) {
    const {
        scalePrices, 
        scalePriceTexts,
        basicPrice,
        activePrice,
        articleCount,
        quantityUnit,
        onArticleCountChange,
        localization
    } = props;
    const trackingLabel = 'bulk-discount-box_';

    if (!Array.isArray(scalePrices) || scalePrices.length === 0) {
        return null;
    }

    return (
        <div className={styles.vd_root}>
            <div className={styles.vd_title}>{localization.generalL10n.volumeDiscountText}</div>
            <div className={styles.vd_container}>
                {scalePrices.map((scalePrice, index) => {
                    const isActiveTile = scalePrice.price.grossValue === activePrice.grossValue;
                    const discount = calculateDiscount(basicPrice.grossValue, scalePrice.price.grossValue);
                    const lineColored = articleCount >= scalePrice.quantity;
                    const unit = scalePrice.quantity > 1 ? quantityUnit.plural : quantityUnit.singular;

                    let prePriceString = scalePriceTexts[index][0].trim();
                    if (prePriceString[prePriceString.length -1] === ':') {
                        prePriceString = prePriceString.slice(0, prePriceString.length -1);
                    }

                    return (
                        <div
                            key={`vd-scale-price-${index}`}
                            className={styles.vd_element}
                            data-testid={trackingLabel + index}
                            data-semantic-id={trackingLabel + index}
                            onClick={() => onArticleCountChange(scalePrice.quantity)}
                        >
                            <div className={classNames(styles.vd_tile, styles.active, styles.status_yellow, {
                                [styles.isActive]: isActiveTile,
                                [styles.border_yellow]: index === 0,
                                [styles.border_green]: index > 0,
                            })}
                            >
                                <div>{prePriceString}</div>
                                <div className={styles.bold_text}>
                                    {localization.generalL10n.savingsText}
                                </div>
                                <div className={classNames({
                                    [styles.bold_text]: index > 0,
                                    [styles.green_text]: index > 0,
                                })}>{discount} %/{unit}</div>
                            </div>
                            <div className={classNames(styles.vd_status_line, {
                                [styles.line_yellow]: lineColored && index === 0,
                                [styles.line_green]: lineColored && index > 0,
                            })}></div>
                        </div>
                    )}
                )}
            </div>
        </div>
    )
}

export default VolumeDiscount;
